<div class="flex-column gap-widget">
	<div class="flex-space-between w-100 gap-L">
		<div class="w-100 top-widget-height">
			<div class="bg-rounded w-100 top-widget-height">
				<application-mini-widget
					[widget]="healthWidget"
					[type]="'availability'"
					[title]="'menu.applicationAvailability' | translate"
				></application-mini-widget>
			</div>
		</div>
		<div class="bg-rounded w-100 top-widget-height">
			<div *ngIf="!initialized" class="border-box-full">
				<app-dashboard-page-loader></app-dashboard-page-loader>
			</div>
			<div *ngIf="initialized" class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-XS font-MM fw-700">
						<span>{{ 'page.workstation.firewall.status' | translate }}</span>
					</div>
				</div>
				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<div [class.success]="!!workstation.isFirewallEnabled" class="font-XL fw-500">
							<span >{{ workstation.isFirewallEnabled === null ? '-' : (workstation.isFirewallEnabled ? 'page.workstation.firewall.enabled' : 'page.workstation.firewall.disabled') | translate }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-rounded w-100 top-widget-height">
			<div *ngIf="!initialized" class="border-box-full">
				<app-dashboard-page-loader></app-dashboard-page-loader>
			</div>
			<div *ngIf="initialized" class="flex-column flex-space-between border-box-full pad-M">
				<div class="flex-align-center flex-space-between gap-S">
					<div class="flex flex-align-center gap-XS font-MM fw-700">
						<span>{{ 'page.workstation.uptime' | translate }}</span>
					</div>
				</div>

				<div class="flex-justify-end w-100">
					<div class="flex-column flex-align-end gap-XS mr-xs" style="max-width: 150px;">
						<div class="font-XL fw-500">
							<span>{{ getUptime() }}</span>
						</div>
						<div class="font-S grey mt-xs">
							{{ getUptimeDate() }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="bg-rounded pad-M-M-0" style="padding-bottom: 5px">
		<app-workstation-information *ngIf="initialized" [workstation]="workstation"></app-workstation-information>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="bg-rounded pad-M">
		<app-workstation-resources *ngIf="initialized" [workstation]="workstation"></app-workstation-resources>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="bg-rounded pad-M">
		<app-workstation-users *ngIf="initialized"></app-workstation-users>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
</div>
